

const Config = {
  types: {
    'panel': 'Plattform-Panel',
    'panel_kladka': 'Fußgängerbrücke',
    'knaga': 'Knagge / T-Poller',
    'drabinka': 'Leiter',
    'barierka': 'Absperrung',
    'deska_okalajaca': 'umgebendes Holzbrett',
    'listwa_odbojowa': 'Prell-Leiste',
    'slupek_pomoc': 'Hilfs-Pfahl',
    'strzalka_trapezowa': 'trapezartiger Fingersteg',
    'strzalka': 'Pfeil',
    'custom': 'Zusätzliches Element',
  }
}


export default Config;
